import type { StoreApi } from 'zustand';
import { useStore } from 'zustand';
import { createStore } from './create-store';

const HIDDEN_KEY = 'chat-hidden-messages';

function loadHidden(): Set<string> {
  try {
    const raw = localStorage.getItem(HIDDEN_KEY);
    return new Set(raw ? (JSON.parse(raw) as string[]) : []);
  } catch {
    return new Set();
  }
}

function persistHidden(ids: Set<string>) {
  try {
    localStorage.setItem(HIDDEN_KEY, JSON.stringify([...ids]));
  } catch { /* quota */ }
}

export interface HiddenMessagesStore {
  ids: Set<string>;
  hide: (id: string) => void;
  clear: () => void;
}

function createHiddenMessagesStore(): StoreApi<HiddenMessagesStore> {
  return createStore<HiddenMessagesStore>('hidden-messages-store', (set, get) => ({
    ids: loadHidden(),
    hide: (id) => {
      const next = new Set(get().ids);
      next.add(id);
      persistHidden(next);
      set({ ids: next });
    },
    clear: () => {
      persistHidden(new Set());
      set({ ids: new Set() });
    },
  }));
}

let store: StoreApi<HiddenMessagesStore> | undefined;

function getHiddenStore(): StoreApi<HiddenMessagesStore> {
  if (!store) store = createHiddenMessagesStore();
  return store;
}

export function useHiddenMessages<T>(selector: (s: HiddenMessagesStore) => T): T {
  return useStore(getHiddenStore(), selector);
}
